import {useEffect} from 'react'

import {V2_FIELDS} from '../schema/contactSchema.js'

export const useTargetBuyerSync = ({targetBuyer, form}) => {
  useEffect(() => {
    if (!targetBuyer) {
      return
    }

    form.setFieldValue(V2_FIELDS.TARGET_BUYER, targetBuyer, {dontUpdateMeta: true})
  }, [targetBuyer, form])
}

export default useTargetBuyerSync
